var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.myCampaignId)?_c('q-dialog',{model:{value:(_vm.dialogCampaign),callback:function ($$v) {_vm.dialogCampaign=$$v},expression:"dialogCampaign"}},[_c('my-campaign-details',{attrs:{"toolbar":true},on:{"close":_vm.onClose}})],1):_c('q-card',{attrs:{"flat":""}},[_c('my-campaign-details',{attrs:{"myCampaignId":_vm.myCampaignId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }